import { render, staticRenderFns } from "./orderBill.vue?vue&type=template&id=05c4bc60&scoped=true"
import script from "./orderBill.vue?vue&type=script&lang=js"
export * from "./orderBill.vue?vue&type=script&lang=js"
import style0 from "./orderBill.vue?vue&type=style&index=0&id=05c4bc60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4bc60",
  null
  
)

export default component.exports